import { forwardRef } from 'react';
import NextButtonWrapper from '../views-components/NextButtonWrapper';
import { SignupDataInput } from './SignupDataInput';
import { useSignupData } from './useSignupData';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const SignupDataInputForm = /*#__PURE__*/forwardRef(({
  button,
  dataKey,
  disabled,
  nextButtonEnabled,
  customValidationError,
  shouldShowPlaceholder,
  renderExtraContent = () => null,
  renderExtraIcons,
  submit,
  type,
  inputMode,
  buttonProps,
  help,
  shouldTrimData = false,
  inputHeight = '',
  labelOverride
}, ref) => {
  const {
    isValid
  } = useSignupData(dataKey);
  const onSubmit = evt => {
    if (evt) evt.preventDefault();
    const isReadyToSubmit = isValid && submit || nextButtonEnabled;
    if (isReadyToSubmit) {
      submit();
    }
  };
  return /*#__PURE__*/_jsxs("form", {
    action: "blue-button-in-all-fields-ios",
    onSubmit: onSubmit,
    children: [/*#__PURE__*/_jsx(SignupDataInput, {
      customValidationError: customValidationError,
      dataKey: dataKey,
      disabled: disabled,
      height: inputHeight,
      help: help,
      inputMode: inputMode,
      labelOverride: labelOverride,
      ref: ref,
      renderExtraIcons: renderExtraIcons,
      shouldShowPlaceholder: shouldShowPlaceholder,
      shouldTrimData: shouldTrimData,
      type: type
    }), renderExtraContent(), !button ? /*#__PURE__*/_jsx(NextButtonWrapper, Object.assign({
      enabled: nextButtonEnabled,
      onClick: onSubmit
    }, buttonProps)) : button]
  });
});